/**
 * The running version, as the last line of the signed-in navigation (V1). Inside the shell only: public and
 * guest pages never render it. It opens What's new.
 */
import { Link } from 'react-router-dom';
import { Tag } from 'lucide-react';
import { cn } from '@/lib/cn';

/** The words of the line, built in one place: what is on screen and what a screen reader says. */
export function versionLine(version: string = __BUILD_INFO__.version): { text: string; name: string } {
  return { text: `v${version}`, name: `Version ${version}, what's new` };
}

export function VersionLine({ compact }: { compact: boolean }) {
  const { text, name } = versionLine();
  return (
    <Link
      to="/whats-new"
      aria-label={name}
      title={compact ? name : undefined}
      className={cn('flex min-w-0 items-center gap-1.5 whitespace-nowrap rounded-control px-2.5 py-1 text-[12px] text-muted hover:bg-shell-hairline/50 hover:text-ink', compact && 'justify-center py-1.5')}
    >
      <Tag className="size-3.5 shrink-0" aria-hidden />
      {!compact && <span className="truncate">{text}</span>}
    </Link>
  );
}
